"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FuseSharedModule = /** @class */ (function () {
    function FuseSharedModule() {
    }
    return FuseSharedModule;
}());
exports.FuseSharedModule = FuseSharedModule;
